import { GoogleGenerativeAI } from "@google/generative-ai";

export const generateBlogPostWithAI = async (topic, apiKey) => {
  if (!apiKey) {
    throw new Error("Chave da API Gemini não fornecida. Configure no painel.");
  }

  const genAI = new GoogleGenerativeAI(apiKey);
  // Default to gemini-flash-latest
  let model = genAI.getGenerativeModel({ model: "gemini-flash-latest" });

  const prompt = `
Você é um redator especialista em tecnologia e negócios, altamente focado em SEO e engajamento.
Aja como um gerador automático de artigos. 
O usuário fornecerá um tema. Sua tarefa é criar um post de blog completo, formatado em HTML nativo, e retornar ESTRITAMENTE um objeto JSON com as informações.

TEMA DO ARTIGO: "${topic}"

Regras do Conteúdo:
1. O texto (content) DEVE estar em HTML. Use tags como <h2>, <h3>, <p>, <ul>, <li> e <strong>.
2. O conteúdo deve ser engajador, direto, profissional e ter em média 4 a 6 parágrafos bem elaborados.
3. Não adicione <h1> no conteúdo, pois o título já será tratado separadamente.
4. Escolha uma "imageKeyword" em INGLÊS com apenas 1 ou 2 palavras, que melhor represente visualmente o artigo. (Ex: "technology", "smartphone", "startup business", "code developer").

Responda APENAS com o JSON no formato exato abaixo. Não adicione blocos de markdown \`\`\`json no início ou no fim, apenas o JSON puro.

{
  "title": "Título incrivelmente atrativo e focado em clique",
  "excerpt": "Um pequeno resumo instigante com até 150 caracteres para chamar atenção do leitor na lista de posts.",
  "content": "<h2>Introdução</h2><p>Texto do artigo aqui...</p>",
  "tags": ["tag1", "tag2", "tag3", "tag4"],
  "imageKeyword": "palavra-chave em inglês"
}
  `;

  try {
    let result;
    try {
      result = await model.generateContent(prompt);
    } catch (modelError) {
      console.warn("Modelo gemini-flash-latest falhou. Tentando fallback para gemini-pro-latest...", modelError.message);
      model = genAI.getGenerativeModel({ model: "gemini-pro-latest" });
      result = await model.generateContent(prompt);
    }
    
    const response = await result.response;
    let text = response.text();
    
    // Clean markdown blocks if the AI returns them
    if (text.startsWith("```json")) {
      text = text.substring(7);
    }
    if (text.startsWith("```")) {
      text = text.substring(3);
    }
    if (text.endsWith("```")) {
      text = text.slice(0, -3);
    }

    const data = JSON.parse(text.trim());
    
    // Usar loremflickr para buscar fotos REAIS ao invés de IA (evita imagens deformadas)
    // Formatamos a palavra-chave trocando espaços por vírgulas para não quebrar a URL
    const randomSeed = Math.floor(Math.random() * 1000);
    const cleanKeyword = (data.imageKeyword || 'technology').trim().replace(/[^a-zA-Z0-9]+/g, ',');
    const imageUrl = `https://loremflickr.com/1200/600/${encodeURIComponent(cleanKeyword)}?lock=${randomSeed}`;

    return {
      title: data.title,
      excerpt: data.excerpt,
      content: data.content,
      tags: data.tags,
      coverImage: imageUrl
    };

  } catch (error) {
    console.error("Erro no aiGenerator:", error);
    throw new Error("Falha ao gerar conteúdo com IA. Verifique sua chave API ou tente novamente. Detalhe: " + error.message);
  }
};
